import {
  faChevronLeft,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
  JoonUIColor,
  Loader,
  Switch,
  TextButton,
  Typography,
} from "@joonapp/web-shared"
import dayjs from "dayjs"
import { useMemo } from "react"

import CreateButtonDropdown from "./CreateButtonDropdown"
import DeleteQuestModal from "./DeleteQuestModal"
import FamilyToggle from "./FamilyToggle"
import QuestModal from "./QuestModal"
import RoutineDate from "./RoutineDate"
import useRoutinesStore from "./useRoutinesStore"
import useMobile from "../../../hooks/useMobile"
import { useAssignedQuestsQuery } from "../../../networking/quests/queries"
import { useScheduledMessagesQuery } from "../../../networking/scheduledMessages/queries"

const RoutinesTab = () => {
  const {
    startDate,
    setStartDate,
    showParentCreatedRoutines,
    setShowParentCreatedRoutines,
  } = useRoutinesStore()
  const { isLoading: isQuestLoading } = useAssignedQuestsQuery(dayjs(startDate))
  const { isLoading: isScheduledMessageLoading } = useScheduledMessagesQuery()
  const isLoading = isQuestLoading || isScheduledMessageLoading

  const isMobile = useMobile()

  const weekDates = useMemo(() => {
    const dates = []
    for (let i = 0; i < 7; i++) {
      dates.push(dayjs(startDate).add(i, "day"))
    }
    return dates
  }, [startDate])

  const goToNextWeek = () => {
    setStartDate(dayjs(startDate).add(1, "week").toDate())
  }

  const goToPreviousWeek = () => {
    setStartDate(dayjs(startDate).subtract(1, "week").toDate())
  }

  if (isMobile) {
    return (
      <div className="flex flex-col p-6 h-[calc(100vh-100px)] overflow-y-auto gap-6 w-full">
        <Typography variant="bodyBold">
          Routine view is not available on mobile
        </Typography>
      </div>
    )
  }

  return (
    <div
      className={`flex flex-col p-6 h-[calc(100vh-100px)] overflow-y-auto gap-6 w-full`}
    >
      <div className="flex flex-row gap-2 items-center justify-between">
        <div className="flex flex-row gap-1 items-center">
          <TextButton onClick={goToPreviousWeek}>
            <FontAwesomeIcon icon={faChevronLeft} />
          </TextButton>
          <TextButton onClick={goToNextWeek}>
            <FontAwesomeIcon icon={faChevronRight} />
          </TextButton>
          <Typography variant="bodyBold">
            {dayjs(startDate).format("MMM D")} -{" "}
            {dayjs(startDate).add(1, "week").format("MMM D")}
          </Typography>
        </div>
        <div className="flex flex-row gap-4 items-center">
          <div className="flex flex-row gap-2 items-center">
            <Switch
              checked={showParentCreatedRoutines}
              onChange={() =>
                setShowParentCreatedRoutines(!showParentCreatedRoutines)
              }
              name="enable"
              variant="small"
            />
            <Typography variant="bodySmall">Parent routines</Typography>
          </div>
          <CreateButtonDropdown />
        </div>
      </div>
      <FamilyToggle />
      {isLoading && (
        <div className="flex flex-row gap-2 items-center">
          <Loader thickness={2} color={JoonUIColor.icon.neutral} size={14} />
        </div>
      )}
      <div className="flex flex-col gap-6">
        {weekDates.map((date) => (
          <RoutineDate key={date.format("YYYY-MM-DD")} date={date} />
        ))}
      </div>
      <QuestModal />
      <DeleteQuestModal />
    </div>
  )
}

export default RoutinesTab
